export enum LoadState {
    Loading,
    Success,
    Fail
}